<template>
  <div style="height: 100%" class="container">
    <listFilter
      :formItems="filterItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    ></listFilter>
    <div class="userMangeTable">
      <div class="topToolBar">
        <Select class="xiala" v-model="currentSystem" @on-change="systemChange">
          <Option
            v-for="item in systemList"
            :value="item.value"
            :label="item.label"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <CustomButton
          type="primary"
          @click="addMenuBtnClick(true)"
          :permissionCode="authType.menu.createMenuAuth"
          :disabled="originalSelectObj.menuType == 3"
          >菜单录入</CustomButton
        >
        <CustomButton
          type="primary"
          @click="exploreAllList"
          >全部展开</CustomButton
        >
        <CustomButton
          type="primary"
          @click="putAwayAllList"
          >全部收起</CustomButton
        >
      </div>
      <div class="tableWrap">
        <div class="tableBox">
          <u-table
            ref="plTreeTable"
            fixed-columns-roll
            beautify-table
            header-drag-style
            :height="uTableHeight"
            :treeConfig="{ children: 'children', iconClose: 'el-icon-folder-add', iconOpen: 'el-icon-folder-remove', expandAll: false }"
            use-virtual
            row-id="id"
            border
            stripe
          >
            <!--u-table大数据表格 你需要在列上指定某个列显示展开收起 treeNode属性-->
            <u-table-column
              v-for="item in columns"
              :tree-node="item.tree"
              :key="item.id"
              :prop="item.key"
              :label="item.title"
              :width="item.width"
              :minWidth="item.minWidth"
              :fixed="item.fixed"
              :align="item.align"
            >
<!--              <template >{{ scope.row.date }}</template>-->
              <template slot-scope="{ row }">
                {{ item.utableRender ? item.utableRender(row) : row[item.key] }}
              </template>
            </u-table-column>
            <u-table-column
              key='action'
              prop="action"
              label="操作"
              :width="390"
              fixed="right"
            >
              <template slot-scope="{ row }">
                <template v-if="row.menuType !== 3">
                  <!-- 可以添加菜单的逻辑：1级菜单+2级菜单 和其他所有的权限菜单 -->
                  <CustomButton class="mg4" v-if="(row.menuType === 1 && row.level < 2) || row.menuType === 2" @click="menuAdd(row)" type="success" size="small" :permissionCode="authType.menu.pageCompomentAuth">菜单录入</CustomButton>
                  <CustomButton class="mg4" @click="pageAuthBtnClick(row)" type="info" size="small" :permissionCode="authType.menu.pageCompomentAuth">控件权限</CustomButton>
                  <CustomButton class="mg4" @click="dataAuthBtnClick(row)" type="info" size="small" :permissionCode="authType.menu.dataRowAuth">行权限</CustomButton>
                  <CustomButton class="mg4" @click="dataColumnAuthBtnClick(row)" type="info" size="small" :permissionCode="authType.menu.dataColumnAuth">列权限</CustomButton>
                </template>
                <CustomButton class="mg4" @click="editRowBtnClick(row)" type="success" size="small" :permissionCode="authType.menu.editMenuAuth">编辑</CustomButton>
                <CustomButton class="mg4" v-if="!['PermissionManagementSystem', 'funcMenuList'].includes(row.menuCode)" @click="deleteBtnClick(row)" type="error" size="small" :permissionCode="authType.menu.deleteRowAuth">删除</CustomButton>
              </template>
            </u-table-column>
          </u-table>
        </div>
      </div>
    </div>
    <Modal
      v-model="displayFormStatus"
      :title="modalTitle"
      @on-cancel="cancelMainForm"
      :loading="modalLoading"
      class="createModalClass"
    >
      <Form
        label-position="left"
        :label-width="100"
        :model="formValidate"
        ref="formValidate"
        :rules="ruleValidate"
      >
        <FormItem label="菜单名称:" prop="menuName">
          <Input
            placeholder="请输入菜单名称"
            v-model="formValidate.menuName"
          ></Input>
        </FormItem>
        <FormItem label="菜单等级:" prop="">
          <span>{{
            formValidate.parentMenuId == 0 ? '一级菜单' : '下级菜单'
          }}</span>
        </FormItem>
        <FormItem label="父菜单:" prop="">
          <span>{{
            currentOpeate == 0
              ? originalSelectObj.menuName || '无'
              : originalSelectObj.parentMenuId == 0
              ? '无'
              : originalSelectObj.parentMenuName || '无'
          }}</span>
        </FormItem>
        <FormItem label="类型: " prop="menuType">
          <Select
            v-model="formValidate.menuType"
            @on-select="menuTypeSelected"
            :disabled="this.currentOpeate == 1"
          >
            <Option
              v-for="item in menuList"
              :value="item.value"
              :key="item.value"
              :disabled="disabledMenuValueArray.includes(item.value)"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="菜单编码：" prop="menuCode">
          <Input
            placeholder="请输入菜单编码"
            v-model="formValidate.menuCode"
          ></Input>
        </FormItem>
        <FormItem label="菜单顺序:" prop="menuSortNum">
          <Input
            placeholder="请输入菜单顺序"
            v-model="formValidate.menuSortNum"
          ></Input>
        </FormItem>
        <FormItem label="状态:" prop="menuStatus">
          <Select v-model="formValidate.menuStatus">
            <Option
              v-for="item in menuStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')"
            >确认</Button
          >
          <Button @click="popCreateMoal" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
    <!-- 页面控件列表弹窗 -->
    <Modal
      v-model="pageCompTableDisplayStatus"
      title="页面控件权限配置"
      class="subTableModal"
    >
      <PageCompomentsView
        :selectedMenuObj="pageComponetMenuSelectRow"
        :currentSystem="currentSystem"
      ></PageCompomentsView>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
    <!-- 数据行权限配置弹窗 -->
    <Modal
      v-model="dataRowAuthTableDisplayStatus"
      title="数据行权限配置"
      class="subTableModal"
    >
      <dataRowAuthVue
        :selectedMenuObj="dataRowMenuSelectRow"
        :currentSystem="currentSystem"
      ></dataRowAuthVue>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
    <!-- 数据列权限表格 -->
    <Modal
      v-model="dataColumnAuthTableDisplayStatus"
      title="数据列权限配置"
      class="subTableModal"
    >
      <dataColumnAuthVue
        :selectedMenuObj="dataColumnMenuSelectRow"
        :currentSystem="currentSystem"
      ></dataColumnAuthVue>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { getColumns, filterItems } from './config';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import ykRule from '../../../assets/js/ykRule';
import { CustomButton } from '../../../components';
import authType from '../../../config/authType';
import PageCompomentsView from './compoments/pageCompoments.vue';
import dataRowAuthVue from './compoments/dataRowAuth.vue';
import dataColumnAuthVue from './compoments/dataColumnAuth.vue';
import util from '@/assets/js/util';
import { alterListExploreOrPutaway } from './methods';

const addMenuURL = '/v1/funcMenu';
export default {
  name: 'reportList',
  tableName: 'menuList',
  mixins: [getPermissionMixin],
  components: {
    CustomButton,
    PageCompomentsView,
    dataRowAuthVue,
    dataColumnAuthVue
  },
  data() {
    return {
      filterItems,
      // 当前点击右侧页面控件按钮的菜单对象
      pageComponetMenuSelectRow: {},
      // 当前点击右侧航权限按钮的菜单对象
      dataRowMenuSelectRow: {},
      // 当前点击右侧列权限按钮的菜单对象
      dataColumnMenuSelectRow: {},
      authType,
      dataColumnAuthTableDisplayStatus: false,
      dataRowAuthTableDisplayStatus: false,
      pageCompTableDisplayStatus: false,
      menuStatusList: [
        { label: '禁用', value: 0 },
        { label: '启用', value: 1 }
      ],

      menuList: [
        { label: '菜单类型', value: 1 },
        { label: '权限类型', value: 2 },
        { label: '登录类型', value: 3 }
      ],
      modalTitle: '新建菜单',
      modalLoading: true,
      // 是否显示新建编辑表单
      displayFormStatus: false,
      // 选中的原始的数据
      originalSelectObj: '',
      // 当前的操作 0菜单录入 1编辑菜单
      currentOpeate: '',
      // 当前所选系统
      currentSystem: '',
      formValidate: {
        appId: '',
        menuCode: '',
        menuName: '',
        menuSortNum: '',
        menuStatus: 1,
        menuType: '',
        parentMenuId: '',
        id: ''
      },
      ruleValidate: {
        menuName: [
          { required: true, message: '菜单名称未填写', trigger: 'blur' }
        ],
        menuCode: [
          { required: true, message: '菜单编码未填写', trigger: 'blur' }
        ],
        menuSortNum: [
          {
            required: true,
            message: '排序权值未填写',
            trigger: 'blur'
          },
          { validator: ykRule.testPositiveNum, trigger: 'blur' }
        ],
        menuType: [
          {
            required: true,
            type: 'number',
            message: '类型未填写',
            trigger: 'change'
          }
        ],
        menuStatus: [{ required: false }],
        parentMenuId: [{ required: false }],
        appId: [{ required: false }]
      },
      columns: [],
      filter: {
        menuName: ''
      }
    };
  },
  computed: {
    ...mapState('menuManage', [
      'totalCount',
      'dataSource',
      'addressList',
      'systemList',
      'dataColumnAuthDataSource',
      'dataColumnAuthCount'
    ]),
    disabledMenuValueArray() {
      // 如果是菜单类型的话 并且如果当前级别是大于一级的，就禁用 登录和菜单，如果是其他类型的话，就禁用
      if (!this.originalSelectObj) return [];
      if (this.originalSelectObj.menuType === 1 && this.originalSelectObj.level >= 1) return [1, 3];
      if (this.originalSelectObj.menuType === 1 && this.originalSelectObj.level === 0) return [3];
      return [];
    },
    uTableHeight() {
      const root = document.getElementById('app');
      const height = root.offsetHeight - 64 - 40 - 20 - 46 - 30;
      return height;
    }
  },
  methods: {
    ...mapMutations('menuManage', ['SAVE_STATE']),
    ...mapActions('menuManage', [
      'getUserPermission',
      'getTableInfo',
      'getaddressList',
      'getSystemList'
    ]),
    callBack(res) {
      const arr =
        res.tableDataColMap == null
          ? []
          : util.getFirstDataByObj(res.tableDataColMap) || [];
      const noShowArr = arr.map(item => item.colName);
      this.columns = getColumns(
        {
          editBtnClick: this.editRowBtnClick,
          deleteBtnClick: this.deleteBtnClick,
          pageAuthBtnClick: this.pageAuthBtnClick,
          dataAuthBtnClick: this.dataAuthBtnClick,
          changeSelect: this.changeSelect,
          dataColumnAuthBtnClick: this.dataColumnAuthBtnClick
        },
        noShowArr
      );
    },
    cancelMainForm() {
      if (this.currentOpeate == 1) {
        this.originalSelectObj = '';
      }
    },
    searchTableInfo() {
      this.getTableInfo({ appid: this.currentSystem, ...this.filter });
    },
    resetTableInfo() {
      this.filter.menuName = '';
      this.getTableInfo({ appid: this.currentSystem, ...this.filter });
    },
    pageInit() {
      this.getSystemList().then(res => {
        if (res.msg == 'success') {
          this.prepareSystem();
          // this.getTableInfo();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    exploreAllList() {
      this.$refs.plTreeTable.setAllTreeExpansion();
      // alterListExploreOrPutaway(this.dataSource, true);
    },
    putAwayAllList() {
      this.$refs.plTreeTable.clearTreeExpand();
      // alterListExploreOrPutaway(this.dataSource, false);
    },
    prepareSystem() {
      const selectedSystem = localStorage.getItem('menuSelectedSystem');
      if (selectedSystem != undefined) {
        // 非首次进入
        this.systemList.forEach(element => {
          if (element.value == selectedSystem) {
            this.currentSystem = selectedSystem;
          }
        });
      } else {
        // 首次进入
        if (this.systemList.length > 0) {
          this.currentSystem = this.systemList[0].value;
          localStorage.setItem('menuSelectedSystem', this.currentSystem);
        }
      }
      this.searchTableInfo();
    },
    popCreateMoal() {
      this.displayFormStatus = false;
    },
    clearMainForm() {
      this.formValidate.menuName = '';
      this.formValidate.menuCode = '';
      this.formValidate.menuSortNum = '';
      this.formValidate.menuStatus = 1;
      this.formValidate.id = '';
      this.formValidate.parentMenuId = '0';
      this.formValidate.menuType = '';
    },
    // 菜单录入 二级及一下
    menuAdd(row) {
      console.log('row', row);
      this.originalSelectObj = { ...row };
      this.addMenuBtnClick(false);
    },
    // 菜单录入 一级
    addMenuBtnClick(isTop) {
      this.currentOpeate = 0;
      if (isTop) {
        // 如果是顶级进入的话
        this.originalSelectObj = '';
      }
      this.clearMainForm();
      if (this.originalSelectObj != '' && !isTop) {
        // 勾选了列表的状态
        this.formValidate.parentMenuId = this.originalSelectObj.id;
        this.formValidate.parentMenuName = this.originalSelectObj.menuName;
        this.formValidate.menuType = this.originalSelectObj.level !== 1 ? this.originalSelectObj.menuType : 2;
        this.formValidate.menuSortNum =
          this.findMenuMaxCount(this.originalSelectObj) > 0
            ? this.findMenuMaxCount(this.originalSelectObj).toString()
            : '1';
      } else {
        // 未勾选
        this.formValidate.menuSortNum = this.findMenuMaxCount('').toString();
      }
      this.displayFormStatus = true;
    },
    findMenuMaxCount(currSelectedObj) {
      let max = 0;
      if (currSelectedObj == '') {
        // 未勾选的
        this.dataSource.forEach(element => {
          if (element.menuSortNum > max) {
            max = element.menuSortNum;
          }
        });
        return max + 1;
      }
      if (
        this.originalSelectObj != '' &&
        this.originalSelectObj.children != undefined &&
        this.originalSelectObj.children.length > 0
      ) {
        this.originalSelectObj.children.forEach(element => {
          if (element.menuSortNum > max) {
            max = element.menuSortNum;
          }
        });
        return max + 1;
      }
      return 0;
    },
    editMenuBtnClick() {
      if (this.originalSelectObj == '') {
        this.$Message.error('未选中菜单无法编辑');
        return;
      }
      this.currentOpeate = 1;
      this.updateRowToForm(this.originalSelectObj);
      this.displayFormStatus = true;
    },
    updateRowToForm(row) {
      this.formValidate.menuCode = row.menuCode;
      this.formValidate.menuName = row.menuName;
      this.formValidate.menuSortNum = row.menuSortNum.toString();
      this.formValidate.menuStatus = row.menuStatus;
      this.formValidate.menuType = row.menuType;
      this.formValidate.parentMenuId = row.parentMenuId;
    },
    editRowBtnClick(row) {
      this.originalSelectObj = row;
      this.currentOpeate = 1;
      this.updateRowToForm(this.originalSelectObj);
      this.displayFormStatus = true;
    },
    deleteBtnClick(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该菜单？',
        loading: true,
        cancelText: '取消',
        onOk: () => {
          this.$ajax.delete(`${addMenuURL}/${row.id}`).then(res => {
            const { data } = res;
            if (data.code == 200) {
              this.$Message.success(data.msg);
              this.$Modal.remove();
              this.originalSelectObj = '';
              this.searchTableInfo();
            } else {
              this.$Message.error(data.msg);
            }
          });
        }
      });
    },
    menuTypeSelected(opt) {
      if (opt.value == 3) {
        this.ruleValidate = {
          ...this.ruleValidate,
          menuCode: {
            required: true,
            message: '菜单编码未填写',
            trigger: 'blur'
          }
        };
      } else {
        this.ruleValidate = {
          ...this.ruleValidate,
          menuCode: { required: false }
        };
      }
    },
    changeSelect(params, e) {
      if (e == true) {
        // 选中当前项
        this.originalSelectObj = { ...params.row };
        this.changeObjSelected(this.dataSource, params);
      } else {
        // 取消选中
        this.originalSelectObj = '';
      }
    },
    pageAuthBtnClick(row) {
      this.pageCompTableDisplayStatus = true;
      this.pageComponetMenuSelectRow = row;
    },

    dataAuthBtnClick(row) {
      this.dataRowAuthTableDisplayStatus = true;
      this.dataRowMenuSelectRow = row;
    },
    dataColumnAuthBtnClick(row) {
      this.dataColumnAuthTableDisplayStatus = true;
      this.dataColumnMenuSelectRow = row;
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.formValidate.appId = this.currentSystem;
          const parms = this.formValidate;
          if (this.currentOpeate == 0) {
            // 新建
            this.$ajax.post(addMenuURL, parms).then(res => {
              const { data } = res;
              if (data.code == 200) {
                this.$Message.success(data.msg);
                this.displayFormStatus = false;
                this.originalSelectObj = '';
                this.searchTableInfo();
              }
            });
          } else if (this.currentOpeate == 1) {
            if (
              (this.formValidate.menuName == '91权限管理系统' &&
                this.formValidate.menuStatus == 0) ||
              (this.formValidate.menuName == '菜单管理' &&
                this.formValidate.menuStatus == 0)
            ) {
              this.$Message.error('该菜单不允许禁用');
              return;
            }
            // 编辑
            this.$ajax
              .put(
                `${addMenuURL}/${this.originalSelectObj.id}`,
                this.formValidate
              )
              .then(res => {
                const { data } = res;
                if (data.code == 200) {
                  this.$Message.success(data.msg);
                  this.displayFormStatus = false;
                  this.originalSelectObj = '';
                  this.searchTableInfo();
                }
              });
          }
        } else {
          this.$Message.error('所填信息异常');
        }
      });
    },
    changeObjSelected(arr, params) {
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        item.selected = false;
        if (
          item.children != undefined &&
          Object.prototype.toString.call(item.children) === '[object Array]' &&
          item.children.length > 0
        ) {
          this.changeObjSelected(item.children, params);
        }
        if (params.row.menuName == item.menuName) {
          item.selected = true;
        }
      }
    },
    // 应用切换
    systemChange(item) {
      this.currentSystem = item;
      this.originalSelectObj = '';
      this.searchTableInfo();
      localStorage.setItem('menuSelectedSystem', this.currentSystem);
    }
  },
  mounted() {
    this.pageInit();
  },
  watch: {
    dataSource: {
      handler (data) {
        this.$refs.plTreeTable.reloadData(data);
        this.$refs.plTreeTable.setAllTreeExpansion();
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.main /deep/ .content-wrapper {
  padding: 0px 10px 10px 10px !important;
}
.container {
  padding: 0 0px;
}
.topToolBar {
  // display: flex;
  position: sticky;
  top: -10px;
  z-index: 100;
  padding-left: 12px;
  padding-top: 7px;
  padding-bottom: 7px;
  background-color: white;
  width: 100%;
  .xiala {
    width: 200px;
  }
  button {
    margin-left: 6px;
    // margin-bottom: 10px;
  }
}
.subTableModal /deep/ .ivu-modal {
  width: 80% !important;
}
.createModalClass /deep/ .ivu-modal-footer {
  padding: 0 !important;
}
.mg4 {
  margin: 4px
}
</style>
